'use client';

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useOptionalSetupProcessorEmbed } from '@/components/setup/experience/SetupProcessorEmbedContext';
import { useOrgNavigate } from '@/hooks/use-app-navigate';

export function useProcessorEditExit() {
  const embed = useOptionalSetupProcessorEmbed();
  const navigate = useNavigate();
  const { orgRoutes } = useOrgNavigate();

  const processorsHref = `${orgRoutes.PAYMENT_FLOWS()}?tab=processors`;

  const exitAfterSave = useCallback(() => {
    if (embed) {
      embed.onComplete();
      return;
    }
    navigate(processorsHref);
  }, [embed, navigate, processorsHref]);

  const exitCancel = useCallback(() => {
    if (embed) {
      embed.onCancel();
      return;
    }
    navigate(processorsHref);
  }, [embed, navigate, processorsHref]);

  return {
    processorsHref,
    exitAfterSave,
    exitCancel,
    isEmbed: Boolean(embed),
  };
}
